// extracted by mini-css-extract-plugin
export default {"header":"veO8eqMJu8g7c3QwerIT","subHeading":"Va3HaOvf5lQEOe9K1Vbp"};